
import { empty as empty_1 } from "../fable-library-js.5.0.0-rc.2/Map.js";
import { comparePrimitives } from "../fable-library-js.5.0.0-rc.2/Util.js";
import { ExtraCoders } from "./Types.fs.js";

export const empty = new ExtraCoders("", empty_1({
    Compare: (x, y) => (comparePrimitives(x, y) | 0),
}));

